  var ws = "";
var g_bConnectWS = false;
var g_splitFlag = "$*$";
var g_bClosed = false; //是否被关闭了
var g_index = 0;      //当前高拍仪设备索引
var onMessageEvent
//开启webSocket
function StartWebSocket() {
	var url = "ws://127.0.0.1:18088";//对应设备端口不能随意更改。设备之间的地址是不同的
	// var url = "ws://127.0.0.1:24012";//对应设备端口不能随意更改。设备之间的地址是不同的

	if ('WebSocket' in window) {
		ws = new WebSocket(url);
	}
	else if ('MozWebSocket' in window) {
		ws = new MozWebSocket(url);
	} else {
		alert("浏览器版本过低身份证读卡器连接失败，请升级您的浏览器。\r\n浏览器要求：IE10+/Chrome14+/FireFox7+/Opera11+");
	}

	ws.onopen = function () {
		g_bConnectWS = true;
		sendInitMsg();//初始化
		g_bClosed = false;
	};


	ws.onmessage = function (evt) {
console.log('接收消息',evt.data);
		if (typeof (evt.data) == "string") {

			var str = evt.data;

			if (str.length <= 0) {

				return;
			}
			//读取身份证显示结果
			if (str.indexOf("@I@") >= 0) {
				var strs = new Array();
				strs = str.split("@I@");
				//alert(strs[1]);
				onMessageEvent(strs[1])
				return;
			}

		}

	};

	ws.onclose = function () {
		g_bConnectWS = false;
		alert("身份证读卡器连接已断开");
	};

}

function sendWsMessage(jsonObj) {
console.log('发送消息');
	var jsonStr = JSON.stringify(jsonObj);
	try {
		ws.send(jsonStr);
	} catch (error) {

	}

}

export function load(onMessage) {
	//连接服务
console.log('连接服务');
	StartWebSocket();
	onMessageEvent = onMessage
}

export function unload() {
	//alert("身份证读卡器断开连接");
	if (g_bClosed) {
		return;
	}
	clearInterval();
	//反初始化
console.log('反初始化');
	var jsonObj = { FuncName: 'UnInitCamLib' };
	sendWsMessage(jsonObj);
}
//初始化
function sendInitMsg() {
console.log('初始化');
	var jsonObj = { FuncName: 'InitCamLib' };
	sendWsMessage(jsonObj);
}



export function readidcard() {
	var jsonObj = { FuncName: 'ReadIDCard' };
	sendWsMessage(jsonObj);
}


